import { Component, OnInit, } from '@angular/core';
import { TopCard } from 'src/app/admihair/api/dto/top-card';
import { TopCardService } from 'src/app/admihair/service/top-card.service';

@Component({
  selector: 'app-dashboard-rfarias',
  templateUrl: './usuario-dashboard.component.html',
  styleUrls: ['./usuario-dashboard.component.scss']
})
export class UsuarioDashBoardComponent implements OnInit {

  constructor(private topCardService: TopCardService) { }

  
  loading: boolean = false;
  loadingTotalLoginsDia: boolean = false;

  totalLoginsDia?: TopCard;

  ngOnInit(): void {
    this.listarEmpresas();
  }

  listarEmpresas(){    
      this.topCardService.totalUsuariosLogadosDia().subscribe({
        next: (data: TopCard) => {
          this.loadingTotalLoginsDia = false;
          this.totalLoginsDia = data;
        },
        error: (err: any) => {
          this.loadingTotalLoginsDia = false;          
        }
      });
    
  }


}
